"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interactionConfig;

var _InteractionConfig = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionConfig"));

function interactionConfig(descriptors) {
  var config = (0, _InteractionConfig.default)(descriptors);
  return Object.assign({}, config, {
    getDefault: function getDefault(localType, defaultType, applicabilityConfig) {
      return config.getDefault(localType, defaultType, applicabilityConfig);
    }
  });
}

module.exports = exports.default;